import { DialogProps, Dialog as MUIDialog } from "@mui/material";

import { Icon } from "../Icon";
import clsx from "clsx";
import { JSX } from "react";

export interface ModalTypes extends DialogProps {
  canClose?: boolean;
  dialogTitle?: string | JSX.Element;
  onClose?: () => void;
  closeOnBackDrop?: boolean;
}

export function Dialog({
  onClose,
  classes,
  className,
  children,
  canClose = true,
  dialogTitle = "",
  closeOnBackDrop = false,
  ...rest
}: ModalTypes) {
  return (
    <MUIDialog
      className={clsx(classes, className)}
      sx={{
        "& .MuiPaper-root": {
          overflow: "visible",
        },
        ...rest.sx,
      }}
      {...rest}
      onClose={canClose && closeOnBackDrop ? onClose : () => {}}
      PaperProps={{ className: "bg-mofidNeutral-05" }}
    >
      <div className="flex px-5 mt-5">
        <Icon
          icon="MdClose"
          className="cursor-pointer text-mofidGray-70 hover:text-mofidRed-130 absolute top-2 left-2 text-lg"
          onClick={() => {
            canClose && onClose && onClose();
          }}
        />
        {dialogTitle && (
          <div className="flex-1 flex items-center text-base font-bold text-mofidBlue-120">
            {dialogTitle}
          </div>
        )}
      </div>
      <div className="overflow-y-auto mt-3">{children}</div>
    </MUIDialog>
  );
}
